import { withTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  min-height: 0;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  background: #fff;
`;

export const Header = styled.header`
  min-height: 6.4rem;
  padding: 0 1rem 0 2rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const HeaderTitle = withTheme(styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.main};

  > svg {
    margin-right: 1rem;
  }

  h6 {
    color: #333;
    line-height: 1.3;
  }

  span {
    display: block;
    color: #777;
    font-size: 1.1rem;
  }
`);

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
`;

export const Messages = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow-y: scroll;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  touch-action: pan-y;
  padding: 2rem 1.5rem;
  background: #f8f9fa;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #eaeaea;
  }
`;

export const Message = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.6rem;

  &.user {
    flex-direction: row-reverse;
  }
`;

export const MessageAvatar = withTheme(styled.div`
  width: 3.2rem;
  min-width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #666;

  &.user {
    background: ${({ theme }) => theme.palette.primary.main};
  }

  svg {
    font-size: 1.8rem;
  }
`);

export const MessageBubble = withTheme(styled.div`
  max-width: calc(100% - 5rem);
  margin-left: 1rem;
  padding: 1rem 1.2rem;
  border-radius: 0.4rem 1.2rem 1.2rem 1.2rem;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  color: #333;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  &.user {
    margin-right: 1rem;
    margin-left: 0;
    border-radius: 1.2rem 0.4rem 1.2rem 1.2rem;
    color: #fff;
    background: ${({ theme }) => theme.palette.primary.main};
  }
`);

export const MessageLink = styled.a`
  color: inherit;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const LoadingContent = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 0.8rem;
    color: #666;
    font-size: 1.2rem;
  }
`;

export const Composer = styled.form`
  padding: 1.2rem 1.5rem 0.8rem;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;

  > div:first-child {
    display: flex;
    align-items: flex-end;
  }

  button {
    margin: 0 0 0.2rem 0.8rem;
  }
`;

export const ComposerHint = styled.p`
  margin-top: 0.5rem;
  color: #777;
  font-size: 1rem;
  text-align: center;
`;
